<!--  -->
<template>
  <div class="feeeback-detail">
    <div>
      <h1>Feedback</h1>
      <ul class="feeeback-detail-con">
        <li>
          <p>To recap some of the highlights from today's meeting</p>
          <div v-html="feedbackDetail.highlights">
            {{feedbackDetail.highlights}}
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'app-project-feedback-interview',
  props: ['feedbackDetail'],
  components: {},
  data () {
    return {
    }
  },
  computed: {},
  mounted () { },
  methods: {}
}
</script>
<style lang='less' scoped>
</style>
